import type {
	PromoCarouselSlideConfig,
	PromoSlidePlatform,
} from "@/app/data/default-promo-slides";

export function isTrocaViaHubPromoSlide(
	slide: PromoCarouselSlideConfig,
): boolean {
	return slide.action === "open-troca-via-hub";
}

export function isAppDownloadPromoSlide(
	slide: PromoCarouselSlideConfig,
): boolean {
	return slide.action === "open-app-download";
}

/** When `platforms` is omitted or empty, a slide is allowed on every platform (legacy behaviour). */
function isSlideAllowedOnPlatform(
	slide: PromoCarouselSlideConfig,
	runtimePlatform: PromoSlidePlatform,
): boolean {
	const p = slide.platforms;
	if (!p || p.length === 0) return true;
	return p.includes(runtimePlatform);
}

/**
 * Home promo filter. Two orthogonal checks run in order:
 *   1. Platform allow-list (`slide.platforms`).
 *   2. Catalog gating: `open-troca-via-hub` and `open-app-download` are always shown (they don't
 *      depend on catalog categories); every other slide requires `category_id` present in the live
 *      catalog (`GET /catalog/categories`). When `validCatalogCategoryIds` is `null` (not loaded),
 *      non-bypass slides stay hidden to avoid flashing broken "Ver …" buttons.
 */
export function filterPromoSlidesForDisplay(
	slides: PromoCarouselSlideConfig[],
	validCatalogCategoryIds: Set<string> | null,
	runtimePlatform: PromoSlidePlatform,
): PromoCarouselSlideConfig[] {
	return slides.filter((slide) => {
		if (!isSlideAllowedOnPlatform(slide, runtimePlatform)) return false;
		if (isTrocaViaHubPromoSlide(slide)) return true;
		if (isAppDownloadPromoSlide(slide)) return true;
		const cid = (slide.category_id ?? "").trim();
		if (!cid) return false;
		if (validCatalogCategoryIds == null) return false;
		return validCatalogCategoryIds.has(cid);
	});
}
